<div class="sh-notification--error">
  <figure class="sh-notification__icon">
    <svg sh-icon [name]="'delete'"></svg>
  </figure>

  <div class="sh-notification__content">
    <h4 class="sh-notification__title">{{ rejectionTranslations.recordRejectedTranslationKey | translate }}</h4>
    <p class="sh-notification__msg">{{ getRejectedBy() | async }} {{ getRejectedInfo() | async }}</p>

    <h5 class="sh-notification__subtitle">{{ 'dossier.evaluation.rejected.motivation' | translate}}</h5>
    <ul class="sh-notification__message-list">
      @if ((getSystemCodeTranslation() | async); as systemCodeTranslation) {
        <li>{{ systemCodeTranslation }}</li>
      }
      @if (getMotivation(); as motivation) {
        <li>{{ motivation }}</li>
      }
    </ul>
  </div>
</div>
